import React, { useState } from 'react';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MapPanel from './components/MapPanel';

const App = () => {
  const [layers, setLayers] = useState({});
  const [layerMetadata, setLayerMetadata] = useState({});
  const [searchLocation, setSearchLocation] = useState(null);

  const handleLayerToggle = (newLayers, activeLayerData) => {

    // Always create a new object reference to trigger re-render
    setLayers({ ...newLayers });

    // Store metadata for all active layers
    if (activeLayerData && typeof activeLayerData === 'object') {
      const newMetadata = {};

      // activeLayerData is now an object with layer IDs as keys
      Object.entries(activeLayerData).forEach(([layerId, layerData]) => {
        if (layerData) {
          newMetadata[layerId] = layerData;
        }
      });

      setLayerMetadata(prev => ({
        ...prev,
        ...newMetadata
      }));
    }
  };

  const handleSearch = (location) => {
    setSearchLocation(location);
  };

  return (
    <div className="h-screen flex flex-col bg-gray-100 relative overflow-hidden">
      <Header onSearch={handleSearch} />

      <div className="flex-1 flex relative min-h-0">
        <Sidebar onLayerToggle={handleLayerToggle} />
        <div className="flex-1 flex flex-col md:ml-0">
          <MapPanel layers={layers} layerMetadata={layerMetadata} searchLocation={searchLocation} />
        </div>
      </div>
    </div>
  );
};

export default App;